const fullMarkdown = `* 夕水(eveningwater),
* 目前在成都工作
-----
技能
-----
* HTML,CSS,JS基础扎实
* 熟悉vue.js,react.js,jQuery以及typescript以及相关的UI框架如element UI,iview等
* 熟悉layUI,bootstrap等框架，熟悉less,sass,stylus
* 对canvas也有接触，如three.js，echarts.js或者原生canvas等基础语法
* 熟悉地图API如百度地图，高德地图
* 高效的自学能力
-----
工作项目
-----
1. [个人网站](http://eveningwater.com/)
2. [大师有空](http://api.soulside.cn/masterv3_web_formal/public/wap/wapmaster/dist/#/?id=1)
3. [阳光助学系统](http://help.qianjiang.kunyueyun.com/#/)
4. [园区服务系统](http://pss.kunyueyun.com/#/login)
5. [企业应用系统](http://pes.kunyueyun.com/#/login)
6. [商家服务系统](http://bss.kunyueyun.com/#/login)
7. [园区官网(旧版)](http://park.kunyueyun.com/#/login)
8. [园区官网(新版)](http://www.kunyueyun.com/)
9. [捧场客后台管理系统](http://www.pengchangke.com.cn/admin/#/)
10. [领梵后台](https://h5.ledfin.cn)
11. 相关APP页面若干
12. 领梵小程序
13. [17素材](http://www.17sucai.com/pins/26618.html)
14. [案例网站](http://case.ledfin.cn/)
15. [案例后台网站](http://case.ledfin.cn/hash/index.html)
16. [报价后台管理系统](http://bj.ledfin.cn/)
-----
> 如果你喜欢这个效果的话,欢迎下载[源码](https://github.com/eveningwater/vue-resume)研究。`
export default fullMarkdown;